import type { ICluster } from '@/types/cluster'
import { CLUSTERS } from '@/lib/constants/clusters'
export const CLUSTERS_TEXT: Record<ICluster, string> = {
  [CLUSTERS.INFORMATION_SECURITY_MANAGEMENT_SYSTEM]: 'Information Security Management System',
  [CLUSTERS.PEOPLE]: 'People',
  [CLUSTERS.PHYSICAL_SECURITY]: 'Physical Security',
  [CLUSTERS.ASSET_MANAGEMENT]: 'Asset Management',
  [CLUSTERS.DATA_PROTECTION]: 'Data Protection',
  [CLUSTERS.IDENTITY_ACCESS_MANAGEMENT]: 'Identity Access Management',
  [CLUSTERS.NETWORKING_SECURITY]: 'Networking Security',
  [CLUSTERS.OPERATIONS_SECURITY]: 'Operations Security',
  [CLUSTERS.CONFIGURATION_MANAGEMENT]: 'Configuration Management',
  [CLUSTERS.SECURE_DEVELOPMENT]: 'Secure Development',
  [CLUSTERS.CHANGE_MANAGEMENT]: 'Change Management',
  [CLUSTERS.RISK_MANAGEMENT]: 'Risk Management',
  [CLUSTERS.INCIDENT_RESPONSE]: 'Incident Response',
  [CLUSTERS.BUSINESS_CONTINUITY]: 'Business Continuity',
  [CLUSTERS.SUPPLY_CHAIN]: 'Supply Chain',
  [CLUSTERS.COMPLIANCE]: 'Compliance',
  [CLUSTERS.AUDIT_NON_CONFORMITIES]: 'Audit Non-Conformities',
  [CLUSTERS.AWARENESS]: 'Awareness',
  [CLUSTERS.COMMUNICATIONS]: 'Communications',
  [CLUSTERS.CRYPTOGRAPHY]: 'Cryptography',
  [CLUSTERS.CUSTOMER_MANAGEMENT]: 'Customer Management',
  [CLUSTERS.INTEGRATED_MANAGEMENT_SYSTEM]: 'Integrated Management System',
  [CLUSTERS.OPERATIONS_MANAGEMENT]: 'Operations Management',
  [CLUSTERS.QUALITY_MANAGEMENT]: 'Quality Management',
  [CLUSTERS.SALES_MANAGEMENT]: 'Sales Management',
  [CLUSTERS.INTERNAL_AUDIT]: 'Internal Audit',
}
export const NO_CLUSTER = 'No Cluster'

export const CLUSTER_SELECTOR = {
  SEARCH_CLUSTERS: 'Search clusters...',
  NO_CLUSTER_FOUND: 'No cluster found.',
}
